import React, { Component } from "react";

class ApplicationSubmitted extends Component {
  state = {
    heading: null,
    showProgressBar: false,
    pageId: "application-submitted"
  };
  componentWillMount() {
    const stepData = this.props.stepData;
    if (!stepData.access) {
      this.props.previousStep(stepData);
    }
    this.props.setHeaderDisplay(
      this.state.heading,
      stepData.displayStep,
      this.state.showProgressBar,
      this.state.pageId,
      stepData.step
    );
  }
  componentDidMount() {
    document.getElementById("root").scrollIntoView();
    window.scrollBy(0, -10);
  }
  render() {
    let submissionSuccess = false;
    if (
      this.props.submissionStatus == 200 &&
      this.props.submissionStatusText == "OK"
    ) {
      submissionSuccess = true;
    }
    return (
      <div className="col-19">
        {submissionSuccess ? (
          <div>
            <h2>
              <img
                src="/images/icons/check-green.svg"
                aria-hidden="true"
                alt=""
              />
              &nbsp; Application Submitted
            </h2>
            <p className="description">
              We have received your visitation application! Processing your
              application takes about 45 days for Virginia residents and 90 days
              for out-of-state residents. Please note that longer processing
              time may be required for applicants that:
            </p>
            <ul className="unstyled-list">
              <li>
                are current or former VADOC employees, contractors, or
                volunteers
              </li>
              <li>are currently on probation or parole</li>
              <li>have felonies on their record</li>
            </ul>
            <p className="description">
              Our staff at the Virginia Department of Corrections will send
              status updates to the email you provided in this application.
              Please add VisitationApplications@vadoc.virginia.gov to your
              contacts to make sure you receive messages from us.
            </p>
            <p className="description">
              If your application is approved, your next step will be to schedule
              a visit using our online scheduling system. Please refer to the <a href="https://vadoc.virginia.gov/family-and-friends/visiting-an-inmate/" title="Visitation">Visitation</a> page for more information. Thank you!
            </p>
            <div className="form-navigation-2">
              <a
                href="https://vadoc.virginia.gov/families-and-friends/visitation"
                className="primary-button"
              >
                Return to Visitation
              </a>
            </div>
          </div>
        ) : (
          <div>
            <h2>
              <img src="/images/icons/declined.svg" aria-hidden="true" alt="" />
              &nbsp; Application Failed to Submit
            </h2>
            <p className="description">
              Unfortunately, it looks like something went wrong on our end. We
              are working to address the issue and apologize for the
              inconvenience. Please try re-submitting your application later.
            </p>
            <p>
              If you have any questions, please contact{" "}
              <a href="mailto:VisitationInquiries@vadoc.virginia.gov">
                VisitationInquiries@vadoc.virginia.gov
              </a>
              . Thank you!
            </p>
          </div>
        )}
      </div>
    );
  }
}
export default ApplicationSubmitted;



// WEBPACK FOOTER //
// ./src/pages/ApplicationSubmitted/ApplicationSubmitted.js